import React from "react";
import * as motion from "motion/react-client";
import StickyNavbar from "../navbar";
import { Link } from "react-router-dom";


const Chapter7SectionTwo = () => {
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  return (
    <div>
      <StickyNavbar />
      <div className="bg-white text-lg text-black p-4 lg:mt-10 mt-20 sm:p-10 lg:px-20">
        <motion.div
          className="mb-8 space-y-5"
          initial="hidden"
          animate="visible"
          variants={fadeIn}
        >
          <motion.h1
            className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center capitalize"
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5 }}
          >
            What is dissemination?
          </motion.h1>

          <motion.p className=" py-5 text-lg" variants={fadeIn}>
            Dissemination means sharing the results of your research. This could
            be sharing findings with:
          </motion.p>
          <ul className="list-disc list-inside space-y-3">
            <li>The community where the research took place</li>
            <li>
              The people who took part in the research (your participants)
            </li>
            <li>Other community health workers and facilities</li>
            <li>Local government</li>
          </ul>
          <div>
            <p className=" text-xl font-medium text-[#005FFF]">It should be a team effort</p>
            <p className="mt-3">
              You likely won’t carry out a research project or its dissemination
              on your own—it’s a team effort. Sharing the process with your
              colleagues and other facilities means it can be more manageable,
              and is likely to have more impact. By working together, you can
              combine resources, share tasks, and make sure your findings reach
              more people. Collaborating in this way not only makes
              dissemination easier, but also makes sure the process benefits
              more people in the community and beyond.
            </p>
          </div>
          <div>
            <p className=" text-xl font-medium text-[#005FFF]">
              Collaborating with other healthcare facilities
            </p>
            <p>
              Research can often have an impact on more than just one community;
              it is likely that other communities and other facilities share an
              interest in learning more about similar topics to you. Issues that
              are affecting your community may be affecting them too
            </p>
            <ul className="list-disc list-inside space-y-5"></ul>
            <li>
              <span className=" font-medium text-lg">
                {" "}
                Joint dissemination projects:
              </span>
              Smaller facilities can collaborate to combine resources and carry
              out larger dissemination events. For example, if your facility is
              small, working with a larger one to disseminate your research
              means you will be able to do more and increase the impact of your
              research, because you have access to more resources.
            </li>
            <li>
              <span className=" font-medium text-lg">
                {" "}
                Sharing your research with other facilities:
              </span>
              Even if you do not collaborate with other healthcare facilities,
              you can still share your findings with them so that they can
              benefit too. This could include arranging presentations,
              workshops, or creating shared reports that can be handed out to
              healthcare workers in similar settings.
            </li>
          </div>
          <div>
            <h2>
              Make sure you have the support and guidance of the Community
              Health Officer (CHO)
            </h2>
            <motion.p className=" py-5 text-lg" variants={fadeIn}>
              As we said, the dissemination process is important because it is
              when you share your research with a wider audience, meaning this
              is when it is likely to make an influence on others and the
              community. Because of the impact it will have, it is very
              important that The Community Health Officer (CHO) is fully on
              board with your research, including during the dissemination
              process. It is important that the CHO:
            </motion.p>
            <motion.ul className="list-disc list-inside space-y-3">
              <motion.li>Is fully informed about the research project from start to finish</motion.li>
              <motion.li>Supports the project and guides how findings are shared</motion.li>
              <motion.li>Approves any community engagement plans </motion.li>
            </motion.ul>
          </div>
        </motion.div>
        <div className="flex justify-between mt-10">
          <Link to="/chapter7">
            <button className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
              Previous
            </button>
          </Link>
          <Link to="/chapter7/sectionThree">
            <button className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
              Next
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Chapter7SectionTwo;
